import { useEffect } from 'react';
import { Loader } from 'src/components/atoms/Loader';
import Modal, { ModalVariant } from 'src/components/organisms/Modal';
import { OwnerForm } from 'src/components/organisms/OwnerForm';
import useOwner from 'src/features/owner/hooks/useOwner';
import { IOwner, IOwnerRequest } from 'src/features/owner/ts/interfaces/Owner';

interface ICreateOwnerModalProps {
  isOpen: boolean;
  closeModal: (payload?: { ownerId: IOwner['id']; ownerName: IOwner['name'] }) => void;
}

const CreateOwnerModal = ({ isOpen, closeModal }: ICreateOwnerModalProps) => {
  const { onCreate, isCreating, createSuccess, owner, onResetCreate } = useOwner();

  const onSave = (owner: IOwner) => {
    onCreate({ owner: owner } as IOwnerRequest);
  };
  useEffect(() => {
    if (createSuccess && owner) {
      onResetCreate();
      // On a successful save, close the modal
      closeModal({ ownerId: owner.id, ownerName: owner.name });
    }
  }, [createSuccess, owner, closeModal, onResetCreate]);

  if (isCreating) {
    return <Loader />;
  }
  return (
    <Modal
      title="Create Owner"
      labelButtonCancel="Cancel"
      labelButtonConfirm="Save"
      showModal={isOpen}
      isBackClosable={false}
      isEscapeClosable={false}
      isDisabledButtonCancel={isCreating}
      isDisabledButtonConfirm={isCreating}
      isLoadingButtonConfirm={isCreating}
      variant={ModalVariant.primary}
      onCancel={closeModal}
      showModalActions={false}
    >
      <OwnerForm onSave={onSave} onCancel={() => closeModal()} />
    </Modal>
  );
};

export default CreateOwnerModal;
